import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";
import { GET_TUTORIALS, CREATE_TUTORIAL } from "../../services/urls";

const emptyBrowse = {
  currentFolderId: null,
  breadcrumbs: [],
  folders: [],
  files: [],
};

const initialState = {
  loading: false,
  createLoading: false,
  browse: emptyBrowse,
  error: null,
};

const extractData = (response) => {
  if (response.data?.status && response.data?.data !== undefined) {
    return response.data.data;
  }
  return response.data;
};

export const fetchTutorialBrowse = createAsyncThunk(
  "tutorials/fetchTutorialBrowse",
  async (folderId, { rejectWithValue }) => {
    try {
      const params = folderId ? { folderId } : {};
      const response = await api.get(`${GET_TUTORIALS}/browse`, { params });
      return extractData(response) || emptyBrowse;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to browse tutorials",
      );
    }
  },
);

export const createTutorial = createAsyncThunk(
  "tutorials/createTutorial",
  async (tutorialData, { rejectWithValue }) => {
    try {
      let response;

      if (tutorialData.type === "video") {
        response = await api.post(CREATE_TUTORIAL, {
          title: tutorialData.title,
          shortDescription: tutorialData.shortDescription,
          type: "video",
          videoUrl: tutorialData.videoUrl,
        });
      } else {
        const formData = new FormData();
        formData.append("title", tutorialData.title);
        formData.append("shortDescription", tutorialData.shortDescription || "");
        formData.append("type", "pdf");
        if (tutorialData.file) {
          formData.append("file", tutorialData.file);
        }

        response = await api.post(CREATE_TUTORIAL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      return extractData(response) ?? response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create tutorial",
      );
    }
  },
);

const tutorialsSlice = createSlice({
  name: "tutorials",
  initialState,
  reducers: {
    clearTutorialsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTutorialBrowse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTutorialBrowse.fulfilled, (state, action) => {
        state.loading = false;
        state.browse = action.payload;
      })
      .addCase(fetchTutorialBrowse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createTutorial.pending, (state) => {
        state.createLoading = true;
        state.error = null;
      })
      .addCase(createTutorial.fulfilled, (state) => {
        state.createLoading = false;
      })
      .addCase(createTutorial.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTutorialsError } = tutorialsSlice.actions;
export default tutorialsSlice.reducer;
